module.exports = __webpack_public_path__ + "img/syukyaku-top-017.4b503858.jpg";